import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TimeField from 'react-simple-timefield';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/time-input.css';

// extracted out so it can be edited
const CustomInput = ({
  onChange,
  value,
  readOnly,
}) => (
  <input
    onChange={onChange}
    value={value}
    readOnly={readOnly}
  />
);


CustomInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
};

class TimeInput extends PureComponent {
  constructor(props) {
    super(props);
    this.changeTime = this.changeTime.bind(this);
  }


  changeTime(e, hhmm) {
    const {
      updateValue,
      readOnly,
    } = this.props;

    const index = hhmm.indexOf(':');
    const hh = hhmm.substr(0, index);
    const mm = hhmm.substr(index + 1);

    updateValue({
      hh,
      mm,
      readOnly,
    });
  }



  render() {
    const {
      hh,
      mm,
      readOnly,
    } = this.props;

    return (
      <TimeField
        value={`${hh}:${mm}`}
        onChange={this.changeTime}
        colon=":"
        readOnly={readOnly}
        input={<CustomInput />}
      />
    );
  }
}

TimeInput.propTypes = {
  updateValue: PropTypes.func,
  hh: PropTypes.string,
  mm: PropTypes.string,
  readOnly: PropTypes.bool,
};


export { TimeInput };
